// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mce-item-table:not([border]) ::ng-deep,
.mce-item-table:not([border]) caption ::ng-deep,
.mce-item-table:not([border]) td ::ng-deep,
.mce-item-table:not([border]) th ::ng-deep,
.mce-item-table[border="0"] ::ng-deep,
.mce-item-table[border="0"] caption ::ng-deep,
.mce-item-table[border="0"] td ::ng-deep,
.mce-item-table[border="0"] th ::ng-deep,
table[style*="border-width: 0px"] ::ng-deep,
table[style*="border-width: 0px"] caption ::ng-deep,
table[style*="border-width: 0px"] td ::ng-deep,
table[style*="border-width: 0px"] th ::ng-deep {
  border: none !important;
}

table tr th,
table tr td {
  border: inherit !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/correspondence/email-read/email-read.component.scss"],"names":[],"mappings":"AAaE;;;;;;;;;;;;EACE,uBAAA;AADJ;;AAKA;;EAEE,0BAAA;AAFF","sourcesContent":["//tiny mce - grid line issue in reading pane\r\n.mce-item-table:not([border]),\r\n.mce-item-table:not([border]) caption,\r\n.mce-item-table:not([border]) td,\r\n.mce-item-table:not([border]) th,\r\n.mce-item-table[border=\"0\"],\r\n.mce-item-table[border=\"0\"] caption,\r\n.mce-item-table[border=\"0\"] td,\r\n.mce-item-table[border=\"0\"] th,\r\ntable[style*=\"border-width: 0px\"],\r\ntable[style*=\"border-width: 0px\"] caption,\r\ntable[style*=\"border-width: 0px\"] td,\r\ntable[style*=\"border-width: 0px\"] th {\r\n  ::ng-deep {\r\n    border: none !important;\r\n  }\r\n}\r\n\r\ntable tr th,\r\ntable tr td {\r\n  border: inherit !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
